import React from 'react'

import FormOption from './FormOption'

const Switch = props => <FormOption type="switch" role="switch" {...props} />

Switch.displayName = 'Switch'

export default Switch
